import ptSignatures from './locales/pt/signatures.json';
import enSignatures from './locales/en/signatures.json';
import esSignatures from './locales/es/signatures.json';
import deSignatures from './locales/de/signatures.json';
import frSignatures from './locales/fr/signatures.json';
import itSignatures from './locales/it/signatures.json';
import zhSignatures from './locales/zh/signatures.json';
import ptBatchRegistration from './locales/pt/batch-registration.json';
import enBatchRegistration from './locales/en/batch-registration.json';
import esBatchRegistration from './locales/es/batch-registration.json';
import deBatchRegistration from './locales/de/batch-registration.json';
import frBatchRegistration from './locales/fr/batch-registration.json';
import itBatchRegistration from './locales/it/batch-registration.json';
import zhBatchRegistration from './locales/zh/batch-registration.json';
import ptAndon from './locales/pt/andon.json';
import enAndon from './locales/en/andon.json';
import esAndon from './locales/es/andon.json';
import deAndon from './locales/de/andon.json';
import frAndon from './locales/fr/andon.json';
import itAndon from './locales/it/andon.json';
import zhAndon from './locales/zh/andon.json';
import zhTasks from './locales/zh/tasks.json';
import zhLicenses from './locales/zh/licenses.json';
import zhSoftwares from './locales/zh/softwares.json';
import itTasks from './locales/it/tasks.json';
import itLicenses from './locales/it/licenses.json';
import itSoftwares from './locales/it/softwares.json';
import frTasks from './locales/fr/tasks.json';
import frLicenses from './locales/fr/licenses.json';
import frSoftwares from './locales/fr/softwares.json';
import deTasks from './locales/de/tasks.json';
import deLicenses from './locales/de/licenses.json';
import deSoftwares from './locales/de/softwares.json';
import esTasks from './locales/es/tasks.json';
import esLicenses from './locales/es/licenses.json';
import esSoftwares from './locales/es/softwares.json';
import enTasks from './locales/en/tasks.json';
import enLicenses from './locales/en/licenses.json';
import enSoftwares from './locales/en/softwares.json';
import ptTasks from './locales/pt/tasks.json';
import ptLicenses from './locales/pt/licenses.json';
import ptSoftwares from './locales/pt/softwares.json';
// Provas online do Simmaq 3DX e download público (namespace `provasSimmaq`).
import ptProvasSimmaq from './locales/pt/provasSimmaq.json';
import enProvasSimmaq from './locales/en/provasSimmaq.json';
import esProvasSimmaq from './locales/es/provasSimmaq.json';
import deProvasSimmaq from './locales/de/provasSimmaq.json';
import frProvasSimmaq from './locales/fr/provasSimmaq.json';
import itProvasSimmaq from './locales/it/provasSimmaq.json';
import zhProvasSimmaq from './locales/zh/provasSimmaq.json';
// Prestação de Contas (namespace `expenses`).
import ptExpenses from './locales/pt/expenses.json';
import enExpenses from './locales/en/expenses.json';
import esExpenses from './locales/es/expenses.json';
import deExpenses from './locales/de/expenses.json';
import frExpenses from './locales/fr/expenses.json';
import itExpenses from './locales/it/expenses.json';
import zhExpenses from './locales/zh/expenses.json';
﻿import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptCommon from './locales/pt/common.json';
import ptNavbar from './locales/pt/navbar.json';
import ptHome from './locales/pt/home.json';
import ptSidebar from './locales/pt/sidebar.json';
import ptAdmin from './locales/pt/admin.json';
import ptLogin from './locales/pt/login.json';
import ptSignup from './locales/pt/signup.json';
import ptProgress from './locales/pt/progress.json';
import ptExams from './locales/pt/exams.json';
import ptAttendance from './locales/pt/attendance.json';
import ptGradeExams from './locales/pt/grade-exams.json';
import ptReports from './locales/pt/reports.json';
import ptCertificates from './locales/pt/certificates.json';
import ptStudentExams from './locales/pt/student-exams.json';
import ptLinkExams from './locales/pt/link-exams.json';
import ptCourses from './locales/pt/courses.json';
import ptCoordinator from './locales/pt/coordinator.json';
import ptStudentExtra from './locales/pt/student-extra.json';
import ptProfessorExtra from './locales/pt/professor-extra.json';
import ptProfile from './locales/pt/profile.json';
import ptAiSearch from './locales/pt/ai-search.json';
import ptAssistant from './locales/pt/assistant.json';
import ptRanking from './locales/pt/ranking.json';
import ptCloud from './locales/pt/cloud.json';
import ptSupport from './locales/pt/support.json';
import ptAugmentedReality from './locales/pt/augmented-reality.json';

import enCommon from './locales/en/common.json';
import enNavbar from './locales/en/navbar.json';
import enHome from './locales/en/home.json';
import enSidebar from './locales/en/sidebar.json';
import enAdmin from './locales/en/admin.json';
import enLogin from './locales/en/login.json';
import enSignup from './locales/en/signup.json';
import enProgress from './locales/en/progress.json';
import enExams from './locales/en/exams.json';
import enAttendance from './locales/en/attendance.json';
import enGradeExams from './locales/en/grade-exams.json';
import enReports from './locales/en/reports.json';
import enCertificates from './locales/en/certificates.json';
import enStudentExams from './locales/en/student-exams.json';
import enLinkExams from './locales/en/link-exams.json';
import enCourses from './locales/en/courses.json';
import enCoordinator from './locales/en/coordinator.json';
import enStudentExtra from './locales/en/student-extra.json';
import enProfessorExtra from './locales/en/professor-extra.json';
import enProfile from './locales/en/profile.json';
import enAiSearch from './locales/en/ai-search.json';
import enAssistant from './locales/en/assistant.json';
import enRanking from './locales/en/ranking.json';
import enCloud from './locales/en/cloud.json';
import enSupport from './locales/en/support.json';
import enAugmentedReality from './locales/en/augmented-reality.json';

import esCommon from './locales/es/common.json';
import esNavbar from './locales/es/navbar.json';
import esHome from './locales/es/home.json';
import esSidebar from './locales/es/sidebar.json';
import esAdmin from './locales/es/admin.json';
import esLogin from './locales/es/login.json';
import esSignup from './locales/es/signup.json';
import esProgress from './locales/es/progress.json';
import esExams from './locales/es/exams.json';
import esAttendance from './locales/es/attendance.json';
import esGradeExams from './locales/es/grade-exams.json';
import esReports from './locales/es/reports.json';
import esCertificates from './locales/es/certificates.json';
import esStudentExams from './locales/es/student-exams.json';
import esLinkExams from './locales/es/link-exams.json';
import esCourses from './locales/es/courses.json';
import esCoordinator from './locales/es/coordinator.json';
import esStudentExtra from './locales/es/student-extra.json';
import esProfessorExtra from './locales/es/professor-extra.json';
import esProfile from './locales/es/profile.json';
import esAiSearch from './locales/es/ai-search.json';
import esAssistant from './locales/es/assistant.json';
import esRanking from './locales/es/ranking.json';
import esCloud from './locales/es/cloud.json';
import esSupport from './locales/es/support.json';
import esAugmentedReality from './locales/es/augmented-reality.json';

import deCommon from './locales/de/common.json';
import deNavbar from './locales/de/navbar.json';
import deHome from './locales/de/home.json';
import deSidebar from './locales/de/sidebar.json';
import deAdmin from './locales/de/admin.json';
import deLogin from './locales/de/login.json';
import deSignup from './locales/de/signup.json';
import deProgress from './locales/de/progress.json';
import deExams from './locales/de/exams.json';
import deAttendance from './locales/de/attendance.json';
import deGradeExams from './locales/de/grade-exams.json';
import deReports from './locales/de/reports.json';
import deCertificates from './locales/de/certificates.json';
import deStudentExams from './locales/de/student-exams.json';
import deLinkExams from './locales/de/link-exams.json';
import deCourses from './locales/de/courses.json';
import deCoordinator from './locales/de/coordinator.json';
import deStudentExtra from './locales/de/student-extra.json';
import deProfessorExtra from './locales/de/professor-extra.json';
import deProfile from './locales/de/profile.json';
import deAiSearch from './locales/de/ai-search.json';
import deAssistant from './locales/de/assistant.json';
import deRanking from './locales/de/ranking.json';
import deCloud from './locales/de/cloud.json';
import deSupport from './locales/de/support.json';
import deAugmentedReality from './locales/de/augmented-reality.json';

import frCommon from './locales/fr/common.json';
import frNavbar from './locales/fr/navbar.json';
import frHome from './locales/fr/home.json';
import frSidebar from './locales/fr/sidebar.json';
import frAdmin from './locales/fr/admin.json';
import frLogin from './locales/fr/login.json';
import frSignup from './locales/fr/signup.json';
import frProgress from './locales/fr/progress.json';
import frExams from './locales/fr/exams.json';
import frAttendance from './locales/fr/attendance.json';
import frGradeExams from './locales/fr/grade-exams.json';
import frReports from './locales/fr/reports.json';
import frCertificates from './locales/fr/certificates.json';
import frStudentExams from './locales/fr/student-exams.json';
import frLinkExams from './locales/fr/link-exams.json';
import frCourses from './locales/fr/courses.json';
import frCoordinator from './locales/fr/coordinator.json';
import frStudentExtra from './locales/fr/student-extra.json';
import frProfessorExtra from './locales/fr/professor-extra.json';
import frProfile from './locales/fr/profile.json';
import frAiSearch from './locales/fr/ai-search.json';
import frAssistant from './locales/fr/assistant.json';
import frRanking from './locales/fr/ranking.json';
import frCloud from './locales/fr/cloud.json';
import frSupport from './locales/fr/support.json';
import frAugmentedReality from './locales/fr/augmented-reality.json';

import itCommon from './locales/it/common.json';
import itNavbar from './locales/it/navbar.json';
import itHome from './locales/it/home.json';
import itSidebar from './locales/it/sidebar.json';
import itAdmin from './locales/it/admin.json';
import itLogin from './locales/it/login.json';
import itSignup from './locales/it/signup.json';
import itProgress from './locales/it/progress.json';
import itExams from './locales/it/exams.json';
import itAttendance from './locales/it/attendance.json';
import itGradeExams from './locales/it/grade-exams.json';
import itReports from './locales/it/reports.json';
import itCertificates from './locales/it/certificates.json';
import itStudentExams from './locales/it/student-exams.json';
import itLinkExams from './locales/it/link-exams.json';
import itCourses from './locales/it/courses.json';
import itCoordinator from './locales/it/coordinator.json';
import itStudentExtra from './locales/it/student-extra.json';
import itProfessorExtra from './locales/it/professor-extra.json';
import itProfile from './locales/it/profile.json';
import itAiSearch from './locales/it/ai-search.json';
import itAssistant from './locales/it/assistant.json';
import itRanking from './locales/it/ranking.json';
import itCloud from './locales/it/cloud.json';
import itSupport from './locales/it/support.json';
import itAugmentedReality from './locales/it/augmented-reality.json';

import zhCommon from './locales/zh/common.json';
import zhNavbar from './locales/zh/navbar.json';
import zhHome from './locales/zh/home.json';
import zhSidebar from './locales/zh/sidebar.json';
import zhAdmin from './locales/zh/admin.json';
import zhLogin from './locales/zh/login.json';
import zhSignup from './locales/zh/signup.json';
import zhProgress from './locales/zh/progress.json';
import zhExams from './locales/zh/exams.json';
import zhAttendance from './locales/zh/attendance.json';
import zhGradeExams from './locales/zh/grade-exams.json';
import zhReports from './locales/zh/reports.json';
import zhCertificates from './locales/zh/certificates.json';
import zhStudentExams from './locales/zh/student-exams.json';
import zhLinkExams from './locales/zh/link-exams.json';
import zhCourses from './locales/zh/courses.json';
import zhCoordinator from './locales/zh/coordinator.json';
import zhStudentExtra from './locales/zh/student-extra.json';
import zhProfessorExtra from './locales/zh/professor-extra.json';
import zhProfile from './locales/zh/profile.json';
import zhAiSearch from './locales/zh/ai-search.json';
import zhAssistant from './locales/zh/assistant.json';
import zhRanking from './locales/zh/ranking.json';
import zhCloud from './locales/zh/cloud.json';
import zhSupport from './locales/zh/support.json';
import zhAugmentedReality from './locales/zh/augmented-reality.json';

const defaultResources = {
  pt: { provasSimmaq: ptProvasSimmaq, expenses: ptExpenses, signatures: ptSignatures, batchRegistration: ptBatchRegistration, andon: ptAndon, tasks: ptTasks, licenses: ptLicenses, softwares: ptSoftwares, common: ptCommon, navbar: ptNavbar, home: ptHome, sidebar: ptSidebar, admin: ptAdmin, login: ptLogin, signup: ptSignup, progress: ptProgress, exams: ptExams, attendance: ptAttendance, gradeExams: ptGradeExams, reports: ptReports, certificates: ptCertificates, studentExams: ptStudentExams, linkExams: ptLinkExams, courses: ptCourses, coordinator: ptCoordinator, studentExtra: ptStudentExtra, professorExtra: ptProfessorExtra, profile: ptProfile, aiSearch: ptAiSearch, assistant: ptAssistant, ranking: ptRanking, cloud: ptCloud, support: ptSupport, augmentedReality: ptAugmentedReality },
  en: { provasSimmaq: enProvasSimmaq, expenses: enExpenses, signatures: enSignatures, batchRegistration: enBatchRegistration, andon: enAndon, tasks: enTasks, licenses: enLicenses, softwares: enSoftwares, common: enCommon, navbar: enNavbar, home: enHome, sidebar: enSidebar, admin: enAdmin, login: enLogin, signup: enSignup, progress: enProgress, exams: enExams, attendance: enAttendance, gradeExams: enGradeExams, reports: enReports, certificates: enCertificates, studentExams: enStudentExams, linkExams: enLinkExams, courses: enCourses, coordinator: enCoordinator, studentExtra: enStudentExtra, professorExtra: enProfessorExtra, profile: enProfile, aiSearch: enAiSearch, assistant: enAssistant, ranking: enRanking, cloud: enCloud, support: enSupport, augmentedReality: enAugmentedReality },
  es: { provasSimmaq: esProvasSimmaq, expenses: esExpenses, signatures: esSignatures, batchRegistration: esBatchRegistration, andon: esAndon, tasks: esTasks, licenses: esLicenses, softwares: esSoftwares, common: esCommon, navbar: esNavbar, home: esHome, sidebar: esSidebar, admin: esAdmin, login: esLogin, signup: esSignup, progress: esProgress, exams: esExams, attendance: esAttendance, gradeExams: esGradeExams, reports: esReports, certificates: esCertificates, studentExams: esStudentExams, linkExams: esLinkExams, courses: esCourses, coordinator: esCoordinator, studentExtra: esStudentExtra, professorExtra: esProfessorExtra, profile: esProfile, aiSearch: esAiSearch, assistant: esAssistant, ranking: esRanking, cloud: esCloud, support: esSupport, augmentedReality: esAugmentedReality },
  de: { provasSimmaq: deProvasSimmaq, expenses: deExpenses, signatures: deSignatures, batchRegistration: deBatchRegistration, andon: deAndon, tasks: deTasks, licenses: deLicenses, softwares: deSoftwares, common: deCommon, navbar: deNavbar, home: deHome, sidebar: deSidebar, admin: deAdmin, login: deLogin, signup: deSignup, progress: deProgress, exams: deExams, attendance: deAttendance, gradeExams: deGradeExams, reports: deReports, certificates: deCertificates, studentExams: deStudentExams, linkExams: deLinkExams, courses: deCourses, coordinator: deCoordinator, studentExtra: deStudentExtra, professorExtra: deProfessorExtra, profile: deProfile, aiSearch: deAiSearch, assistant: deAssistant, ranking: deRanking, cloud: deCloud, support: deSupport, augmentedReality: deAugmentedReality },
  fr: { provasSimmaq: frProvasSimmaq, expenses: frExpenses, signatures: frSignatures, batchRegistration: frBatchRegistration, andon: frAndon, tasks: frTasks, licenses: frLicenses, softwares: frSoftwares, common: frCommon, navbar: frNavbar, home: frHome, sidebar: frSidebar, admin: frAdmin, login: frLogin, signup: frSignup, progress: frProgress, exams: frExams, attendance: frAttendance, gradeExams: frGradeExams, reports: frReports, certificates: frCertificates, studentExams: frStudentExams, linkExams: frLinkExams, courses: frCourses, coordinator: frCoordinator, studentExtra: frStudentExtra, professorExtra: frProfessorExtra, profile: frProfile, aiSearch: frAiSearch, assistant: frAssistant, ranking: frRanking, cloud: frCloud, support: frSupport, augmentedReality: frAugmentedReality },
  it: { provasSimmaq: itProvasSimmaq, expenses: itExpenses, signatures: itSignatures, batchRegistration: itBatchRegistration, andon: itAndon, tasks: itTasks, licenses: itLicenses, softwares: itSoftwares, common: itCommon, navbar: itNavbar, home: itHome, sidebar: itSidebar, admin: itAdmin, login: itLogin, signup: itSignup, progress: itProgress, exams: itExams, attendance: itAttendance, gradeExams: itGradeExams, reports: itReports, certificates: itCertificates, studentExams: itStudentExams, linkExams: itLinkExams, courses: itCourses, coordinator: itCoordinator, studentExtra: itStudentExtra, professorExtra: itProfessorExtra, profile: itProfile, aiSearch: itAiSearch, assistant: itAssistant, ranking: itRanking, cloud: itCloud, support: itSupport, augmentedReality: itAugmentedReality },
  zh: { provasSimmaq: zhProvasSimmaq, expenses: zhExpenses, signatures: zhSignatures, batchRegistration: zhBatchRegistration, andon: zhAndon, tasks: zhTasks, licenses: zhLicenses, softwares: zhSoftwares, common: zhCommon, navbar: zhNavbar, home: zhHome, sidebar: zhSidebar, admin: zhAdmin, login: zhLogin, signup: zhSignup, progress: zhProgress, exams: zhExams, attendance: zhAttendance, gradeExams: zhGradeExams, reports: zhReports, certificates: zhCertificates, studentExams: zhStudentExams, linkExams: zhLinkExams, courses: zhCourses, coordinator: zhCoordinator, studentExtra: zhStudentExtra, professorExtra: zhProfessorExtra, profile: zhProfile, aiSearch: zhAiSearch, assistant: zhAssistant, ranking: zhRanking, cloud: zhCloud, support: zhSupport, augmentedReality: zhAugmentedReality }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: defaultResources,
    fallbackLng: 'pt',
    load: 'languageOnly',
    supportedLngs: ['pt', 'en', 'es', 'de', 'fr', 'it', 'zh'],
    ns: ['provasSimmaq', 'expenses', 'signatures', 'batchRegistration', 'andon', 'tasks', 'licenses', 'softwares', 'common', 'navbar', 'home', 'sidebar', 'admin', 'login', 'signup', 'progress', 'exams', 'attendance', 'gradeExams', 'reports', 'certificates', 'studentExams', 'linkExams', 'courses', 'coordinator', 'studentExtra', 'professorExtra', 'profile', 'aiSearch', 'assistant', 'ranking', 'cloud', 'support', 'augmentedReality'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'sessionStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
